import { render } from "./TestSelect.vue?vue&type=template&id=46786afe&scoped=true&ts=true"
import script from "./TestSelect.vue?vue&type=script&lang=ts"
export * from "./TestSelect.vue?vue&type=script&lang=ts"

import "./TestSelect.vue?vue&type=style&index=0&id=46786afe&scoped=true&lang=css"

import exportComponent from "/home/runner/work/octopus-lobby/octopus-lobby/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46786afe"]])

export default __exports__